import e,{css as r}from"../../node_modules/styled-components/dist/styled-components.esm.js";import{defaultTheme as t}from"../../theme/index.js";const o=t["theme"],i=e.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  width: max-content;
  font-family: ${o.mainFont};
  background: ${o.colorVariables.bgAccent};
  ${e=>{switch(null!==(e=e.$size)&&void 0!==e?e:"medium"){case"large":return r`
        height: 32px;
        border-radius: 16px;
      `;case"small":case"extraSmall":return r`
        height: 20px;
        border-radius: 12px;
      `;default:return r`
        height: 24px;
        border-radius: 12px;
      `}}};

  ${e=>e.$transparentMode&&r`
      background: rgba(243, 249, 255, 0.55);
      backdrop-filter: blur(4px);
      box-shadow: ${o.shadowVariables.componentContainer};
    `}
`,a=e.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${o.colorVariables.textLight};
  background: ${e=>7<=e.$rating?o.colorVariables.bgRatingGood:o.colorVariables.bgRatingNormal};
  cursor: default;

  ${({$size:e})=>{switch(e){case"extraSmall":return r`
          ${o.mixin.fontButtonS};
          font-weight: 700;
          border-radius: 12px;
          width: 32px;
        `;case"large":return r`
          ${o.mixin.fontTitleS};
          border-radius: 16px;
          width: 46px;
        `;default:return r`
          ${o.mixin.fontTitleXS};
          border-radius: 12px;
          width: 40px;
        `}}}
`,n=e.a`
  ${o.mixin.buttonStyleReset};
  ${o.mixin.fontButtonS};
  text-decoration: none;
  padding-left: 8px;
  transition: 0.2s ease-in-out;
  padding-right: ${e=>"large"===e.$size?"12px":"8px"};

  ${({$isInteractive:e,$transparentMode:t})=>e?r`
          color: ${t?o.colorVariables.linkHover:o.colorVariables.link};
          cursor: pointer;

          :hover {
            color: ${t?o.colorVariables.link:o.colorVariables.linkHover};
          }
        `:r`
          color: ${t?o.colorVariables.textLight:o.colorVariables.textNoteVeryDark};
          cursor: default;
        `}
`;export{n as Feedbacks,a as Rating,i as StyledRating};
